import "./Poll.scss";
import { FormattedMessage, useIntl } from "react-intl";
import LabelLang from "component/LabelLang/label-lang";
import { END_POINTS } from "constants/APIConstant";
import useSWR from "swr";
import { useDispatch, useSelector } from "react-redux";
import SurveyCard from "./components/SurveyCard";
import usePostHook from "services/ApiPostService";
import { Button } from "react-bootstrap";
import ChevronIcon from "svg-icons/chevron-icon";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MESSAGE_TYPE } from "redux/constants/ApiMessageResponse";
import { apiResponseMessage } from "redux/actions/ApiMessageResponse";
import { useEffect, useState } from "react";

function Poll() {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [surveyComment, setSurveyComment] = useState(null);
  const currentLocale = useSelector(({ theme }) => theme.locale);
  const dir = useSelector(({ theme }) => theme.direction);

  const [surveyList, setSurveyList] = useState([]);

  useEffect(() => {
    var listOfSurveys = JSON.parse(localStorage.getItem("surveyList"));
    listOfSurveys && setSurveyList(listOfSurveys);
  }, []);

  const surveyFetching = useSWR({ url: END_POINTS.SURVEY_HOME });

  const getToastDirection = () => {
    return currentLocale === "ltr" ? "top-right" : "top-left";
  };
  const onPostCallBack = (result) => {
    if (result.state) {
      localStorage.setItem(
        "surveyList",
        JSON.stringify([surveyFetching?.data?.data?.id, ...surveyList])
      );
      setSurveyList(JSON.parse(localStorage.getItem("surveyList")));
      toast(intl.formatMessage({ id: "sent-successfully" }), {
        type: "success",
        position: getToastDirection(),
      });
    }
  };
  const [postState, doPost] = usePostHook({ onPostCallBack });
  let surveyArray = [];
  const onChange = ({ questionId, optionId }) => {
    const questionIndex = surveyArray.findIndex(
      (question) => question.surveyQuestionId == questionId
    );
    if (questionIndex == -1) {
      surveyArray.push({
        surveyQuestionId: questionId,
        surveyQuestionOptionId: optionId,
      });
    } else {
      surveyArray[questionIndex] = {
        surveyQuestionId: questionId,
        surveyQuestionOptionId: optionId,
      };
    }
  };
  const addSurvey = () => {
    const requestBody = {
      surveyId: getSurveyQuestions({ attributeKey: "id" }),
      comment: surveyComment,
      surveyQuestionOptionVote: surveyArray,
    };
    if (
      getSurveyQuestions({ attributeKey: "surveyQuestion" })?.length ===
      surveyArray?.length
    ) {
      doPost({
        url: END_POINTS.SURVEY_VOTE,
        data: requestBody,
      });
      // dispatch(
      //   apiResponseMessage({
      //     showMessage: true,
      //     message: <FormattedMessage id="sent-successfully" />,
      //     messageType: MESSAGE_TYPE.SUCCESS,
      //   })
      // );
    } else {
      dispatch(
        apiResponseMessage({
          showMessage: true,
          message: <FormattedMessage id="must_fill_all_answers" />,
          messageType: MESSAGE_TYPE.ERROR,
        })
      );
    }
  };
  const getSurveyQuestions = ({ attributeKey }) => {
    if (
      surveyFetching &&
      !surveyFetching.error &&
      !surveyFetching.isLoading &&
      surveyFetching.data.data.surveyQuestion
    ) {
      return surveyFetching.data.data[attributeKey];
    }
    return [];
  };

  return surveyFetching?.data?.data?.surveyQuestion ? (
    <div className={`Poll ${dir === "ltr" && "ltr"}`}>
      <ToastContainer />
      {surveyList?.includes(surveyFetching?.data?.data?.id) ? (
        <div className="m__title">
          <h3>
            <FormattedMessage id="poll" />
          </h3>
          <h4 className="py-5 text-center main-color">
            <FormattedMessage id="sharing-thanks" />
          </h4>
        </div>
      ) : (
        <div>
          <div className="m__title">
            <h3>
              <FormattedMessage id="poll" />
            </h3>
          </div>
          <div className="item-p ">
            <p>
              <LabelLang
                id="title"
                defaultValue={getSurveyQuestions({ attributeKey: "title" })}
                translations={getSurveyQuestions({
                  attributeKey: "surveyTranslation",
                })}
              />
            </p>
          </div>
          {getSurveyQuestions({ attributeKey: "surveyQuestion" }).map(
            (question, i) => (
              <SurveyCard
                key={i}
                question={question}
                onRadioChange={onChange}
              />
            )
          )}
          <textarea
            value={surveyComment}
            className={"form-control"}
            rows={5}
            placeholder={intl.formatMessage({ id: "survey-comment" })}
            onChange={(e) => setSurveyComment(e.target.value)}
          />
          <div className="row-r mt-5">
            <Button onClick={addSurvey} className="main-btn">
              <span>
                <FormattedMessage id={"submit"} />
              </span>
              <ChevronIcon width={12} height={12} color="#FFFFFF" />
            </Button>
          </div>
        </div>
      )}
    </div>
  ) : null;
}

export default Poll;
